import { random } from '@sama/micro-dash';
import { DateAnswer } from '../../team-apis/otterdam/answers/date-answer';
import { DateOutput } from '../../team-apis/otterdam/outputs/date-output';
import { OutputHelper } from './output-helper';

export class DateOutputHelper extends OutputHelper<DateOutput, DateAnswer> {
  override getLabelFor(answer: DateAnswer | undefined) {
    return answer ? answer.split('T')[0] : '';
  }

  override makeRandomAnswer() {
    return new Date(random(1e12, 2e12)).toISOString();
  }
}
